module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_malayalam.81888ea4.mp3";